import React, { FunctionComponent } from 'react';
import { Platform, DeviceType, Orientation, WriteDirection } from 'sofa-reborn-react';
import SkapaIconButton from '@ingka/button';
import { KompisTooltip } from '@inter-ikea-kompis/react-components';
import ArrowLeftRightIconPaths from '@ingka/ssr-icon/paths/arrow-left-right';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { localeService } from '../../services';
import { ButtonDiv, StyledIconWrapper } from './ArmrestPopoverButtonStyle';
import { PopoverDirectionEnum } from '@inter-ikea-kompis/component-popover';

type Props = {
	platform: Platform;
	deviceType: DeviceType;
	orientation: Orientation;
	writeDirection: WriteDirection;
	showChangeArmrestButton?: boolean;
	showInfoButton?: boolean;
	onClickChangeArmrest?: () => void;
};

const ArmrestPopoverButton: FunctionComponent<Props> = (props) => {
	const { onClickChangeArmrest, showChangeArmrestButton } = props;
	return (
		<div>
			{showChangeArmrestButton && (
				<ButtonDiv
					writeDirection={props.writeDirection}
					platform={props.platform}
					showInfoButton={props.showInfoButton as boolean}
					showRemoveButton={true}
				>
					{props.deviceType === 'mobile' ||
					props.deviceType === 'tablet' ||
					props.platform === 'kiosk' ? (
						<SkapaIconButton
							iconOnly
							ssrIcon={ArrowLeftRightIconPaths}
							type={'tertiary'}
							aria-label={localeService.getTranslation('armrestSelectorHeader')}
							onClick={(): void => onClickChangeArmrest && onClickChangeArmrest()}
						/>
					) : (
						<KompisTooltip
							theme={SkapaTheme}
							text={localeService.getTranslation('armrestSelectorHeader')}
							direction={PopoverDirectionEnum.top}
							zIndex={5}
						>
							<StyledIconWrapper>
								<SkapaIconButton
									iconOnly
									ssrIcon={ArrowLeftRightIconPaths}
									type={'tertiary'}
									aria-label={localeService.getTranslation('armrestSelectorHeader')}
									onClick={(): void => onClickChangeArmrest && onClickChangeArmrest()}
								/>
							</StyledIconWrapper>
						</KompisTooltip>
					)}
				</ButtonDiv>
			)}
		</div>
	);
};
export default ArmrestPopoverButton;
